import Modal, { ModalBody } from '@redbubble/design-system/src/Modal';
import { dispatch, OPEN_MODAL, useSubscribeTo } from '@redbubble/next-events';
import React, { useState } from 'react';
export var ModalSize;
(function (ModalSize) {
    ModalSize["Small"] = "small";
    ModalSize["Medium"] = "medium";
    ModalSize["Large"] = "large";
})(ModalSize || (ModalSize = {}));
export var Modals = function () {
    var _a = useState(null), modal = _a[0], setModal = _a[1];
    useSubscribeTo(OPEN_MODAL, function (desired) {
        setModal(desired);
    });
    if (!modal) {
        return null;
    }
    return (React.createElement(Modal, { accessibleTitle: modal.accessibleTitle, onCloseRequested: function () {
            setModal(null);
            if (modal.onCloseRequested)
                modal.onCloseRequested();
        }, 
        // the default size of the modal is SMALL in the DS
        size: modal.size, open: true },
        React.createElement(ModalBody, null, modal.content)));
};
export function useOpenModal() {
    return dispatch(OPEN_MODAL);
}
